import React from 'react';
import { Modal } from '@upgrade/react-components';
import Video from '../Video';

export default ({ title, videoUrl, visible, onClose, padding, maxWidth, size = 'auto' }) => (
  <Modal {...{ visible, onClose, padding, maxWidth, size }} shouldCloseOnOverlayClick>
    <Video title={title} {...{ videoUrl }} />
  </Modal>
);
